const textFieldFormParamUser = {
  name: 'Nombre completo',
  email: 'E-mail',
  
};

export default textFieldFormParamUser;
